// src/routes/AppRouter.js - Updated
import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Home from "../pages/Home";
import Mainheader from "../components/Mainheader";
import PageNotFound from "../pages/PageNotFound";
import PreSchoolDetails from '../pages/PreSchooLDetails'
import Footer from "../pages/Footer";
import VideoPage from "../pages/VideoPage";
import PicturePage from "../pages/PicturePage";
import Games from "../pages/Games";
import LearningToys from "../pages/LearningToys";
import CurriculumCombineBooks from "../pages/CurriculumCombineBooks";
import Printable from "../pages/Printable";
import VideoList from "../pages/VidoeList";
import WeeklyPlan from "../pages/WeeklyPlans";
import TalkWithAi from "../pages/TalkWithAi";
import StarOfMonth from "../pages/StarOfMonth";
import Testimonial from "../pages/Testimonial";
import JoliPhonics from "../pages/JoliPhonics";
import ComingSoon from "../pages/ComingSoon";
import IslamicGallery from "../pages/IslamicGallery";
import UrduSounds from "../pages/UrduSounds";
import DarazToys from "../pages/DarazToys";
import DailyPlan from "../pages/DailyPlan";
import WeeklyPaidPlan from "../pages/WeeklyPaidPlan";
import Store from "../pages/Store";
import AdminLogin from "../pages/AdminLogin";
import AdminDashboard from "../pages/AdminDashboard";
import AdminOrders from "../pages/AdminOrders";
import ProtectedRoute from "../pages/ProtectedRoute";

function AppRouter() {
  const location = useLocation();
  const hideFooterRoutes = ["/talk-ai"];

  const hideHeaderRoutes = ["/store", "/admin", "/admin/dashboard", "/admin/orders"];
  const shouldHideHeader = hideHeaderRoutes.includes(location.pathname);

  return (
    <>
      {!shouldHideHeader && <Mainheader />}

      <div>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="preschool" element={<PreSchoolDetails />} />
          <Route path="printable" element={<Printable />} />
          <Route path="games" element={<Games />} />
          <Route path="learning-toys" element={<LearningToys />} />
          <Route path="curriculum" element={<CurriculumCombineBooks />} />
          <Route path="videos" element={<VideoPage />} />
          <Route path="youtube" element={<VideoList />} />
          <Route path="pics" element={<PicturePage />} />
          <Route path="weekly-plan" element={<WeeklyPlan />} />
          <Route path="talk-ai" element={<TalkWithAi />} />
          <Route path="star-of-the-month" element={<StarOfMonth />} />
          <Route path="parents-feedback" element={<Testimonial />} />
          <Route path="jolly-phonics" element={<JoliPhonics />} />
          <Route path="urdu-sounds" element={<UrduSounds />} />
          <Route path="daraz-toys-link" element={<DarazToys />} />
          <Route path="/:week/:day" element={<DailyPlan />} />
          <Route path="coming-soon" element={<ComingSoon />} />
          <Route path="islamic-gallery" element={<IslamicGallery />} />
          <Route path="english-paid-plan" element={<WeeklyPaidPlan />} />
          <Route path="store" element={<Store />} />
          <Route path="admin" element={<AdminLogin />} />
          <Route path="admin/dashboard" element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          } />
          <Route path="admin/orders" element={
            <ProtectedRoute>
              <AdminOrders />
            </ProtectedRoute>
          } />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </div>
      {!hideFooterRoutes.includes(location.pathname) && <Footer />}
    </>
  );
}

export default AppRouter;